'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = error;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    show_error: false,
    message_error: '',
    count_errors: 0,
    is_show_404: false,
    showAlert: false,
    alertType: null,
    server_not_found: false,
    error_code: '',
    error_title: ''
};

function error() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    if (action.type == '@@router/LOCATION_CHANGE' && __CLIENT__) {
        if (action.payload.pathname !== state.is_show_404) {
            return (0, _extends3.default)({}, state, {
                is_show_404: false,
                show_error: false
            });
        }
    }

    if (action.show_error === true) {
        return (0, _extends3.default)({}, state, {
            show_error: true,
            message_error: action.error.message || '',
            count_errors: state.count_errors + 1,
            is_show_404: action.show_404,
            error_code: action.error.code,
            error_title: action.error.title
        });
    } else if (action.show_error === false) {
        return (0, _extends3.default)({}, state, {
            show_error: false,
            message_error: '',
            count_errors: 0,
            server_not_found: action.server_not_found,
            error_code: '',
            error_title: ''
        });
    } else if (action.disable_404) {
        return (0, _extends3.default)({}, state, {
            is_show_404: false
        });
    }

    return state;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/error.js
// module id = 1900
// module chunks = 0